import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '@chakra-ui/react'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const NewSpeedDialModalParts = [
  'footerContainer',
  'bodyContainer',
  'dropdownContainer',
  'dropdownLabel',
  'inputContainer',
  'inputLabel',
] as const

const helpers = createMultiStyleConfigHelpers(NewSpeedDialModalParts)
export const NewSpeedDialModalStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    bodyContainer: {
      flexDirection: 'column',
      paddingY: '0.25rem',
      paddingX: '1rem',
      gap: '1.5rem',
    },
    inputContainer: {
      flexDirection: 'column',
      gap: '0.25rem',
    },
    inputLabel: {
      textStyle: textStyleKeys.Body4_Bold,
    },
    footerContainer: {
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: '0.62rem',
    },
  },
})

export const useNewSpeedDialModalStyle = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig(
    getName({ NewSpeedDialModalStyle }),
    props,
  ) as MultiStyleType<typeof NewSpeedDialModalParts>
}
